package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.LoadingAddress
import com.milta.feature.route.domain.repository.LoadingAddressRepository

/** GET /api/v1/loading-addresses (MIL-99) — last used first. */
class GetLoadingAddressesUseCase(private val repository: LoadingAddressRepository) {
    suspend operator fun invoke(): Result<List<LoadingAddress>> = repository.getLoadingAddresses()
}
